let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // One failing subscriber must not skip the ones after it (the sticky add
      // to cart button's spinner reset, the free-gifts bar), nor abort the
      // publisher's own code. The error is still reported, so Clarity sees it.
      try {
        callback(data);
      } catch (error) {
        if (typeof window.reportError === "function") {
          window.reportError(error);
        } else {
          console.error(error);
        }
      }
    });
  }
}
